import React, { Component } from 'react'

import Group from '../components/group'
import Reports from '../components/reports'
import Videos from '../components/videos'

import $ from 'jquery'

const LINKS = [
  {
    title: '',
    subtitle: '',
    url: '5i2D44VYK8E'
  },
  {
    title: '',
    subtitle: '',
    url: 'tpvp07Ty-zU'
  }
]

export default class GroupPage extends Component {
  componentDidMount() {
    if ($('.Group')) {
      $('html, body').animate(
        { scrollTop: $('.Group').offset().top - 83 },
        1000
      )
    }
  }

  componentDidUpdate() {
    if ($('.Group')) {
      $('html, body').animate(
        { scrollTop: $('.Group').offset().top - 83 },
        1000
      )
    }
  }

  render() {
    return (
      <div className="Group">
        <Group />
        <Reports />
        <Videos links={LINKS} title={"Einzelvideos Teilnehmer"} />
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/pages/grouppage.js
 **/